module.exports = __webpack_public_path__ + "static/media/CSR.7f691c85.png";